/**
 * Capacitor App.getInfo()의 `build` 필드를 정수로 변환.
 *
 * - Android: `versionCode` (정수, 빌드마다 1씩 증가). 예: "14"
 * - iOS: `CFBundleVersion` (보통 정수지만 "1.2.3"처럼 문자열도 허용). 예: "14" 또는 "1.2.3"
 *
 * iOS에서 "1.2.3" 같은 문자열이 올 수 있으므로 semver 대비 메이저 숫자만 사용하는 fallback 포함.
 * 운영에서는 integer 포맷으로 통일 권장.
 */
export function parseBuildToVersionCode(build: string | undefined | null): number {
  if (!build) return 0;
  const trimmed = String(build).trim();
  if (!trimmed) return 0;

  // 순수 정수면 바로 변환
  const asInt = Number.parseInt(trimmed, 10);
  if (!Number.isNaN(asInt) && String(asInt) === trimmed) {
    return asInt;
  }

  // "1.2.3" 같은 semver: major*10000 + minor*100 + patch (뒤섞임 방지)
  const parts = trimmed.split(".").map((p) => Number.parseInt(p, 10));
  if (parts.every((p) => !Number.isNaN(p))) {
    const [maj = 0, min = 0, patch = 0] = parts;
    return maj * 10_000 + min * 100 + patch;
  }

  // 해석 불가 → 0 (fail-open: 최소 요구 버전이 0 이상이면 차단)
  return 0;
}
